import { Extension, nodeInputRule } from '@tiptap/core';

/**
 * Compatibility helper for horizontal rules when zero-width spaces are present.
 * PreserveEmptyLines extension injects a zero-width space in empty lines,
 * which breaks the default HR input rule. This rule tolerates the leading ZWSP.
 */
export const HorizontalRuleMarkdown = Extension.create({
    name: 'horizontalRuleCompat',

    addInputRules() {
        // Allow optional zero-width space before --- / ___ / ***
        const HR_REGEX = /^\u200B?(?:---|___|\*\*\*)\s$/;
        return [
            nodeInputRule({
                find: HR_REGEX,
                type: this.editor.schema.nodes.horizontalRule,
            }),
        ];
    },
});
